import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import toast from 'react-hot-toast';
import LoadingSpinner from '../components/LoadingSpinner';

const DepartmentsAdd = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await api.post('/departments', {
        name: data.name,
        description: data.description || null
      });
      toast.success('Dział został dodany pomyślnie');
      reset();
      navigate('/app/departments/list');
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Błąd podczas dodawania działu';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h2 className="text-xl">Dodaj dział</h2>
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div>
            <label htmlFor="name" className="block text-sm text-gray-700 mb-2">
              Nazwa działu <span className="text-red-500">*</span>
            </label>
            <input
              {...register('name', {
                required: 'Nazwa działu jest wymagana',
                minLength: {
                  value: 2,
                  message: 'Nazwa działu musi mieć co najmniej 2 znaki'
                }
              })}
              type="text"
              id="name"
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
              placeholder="np. Administracja"
            />
            {errors.name && (
              <p className="mt-1 text-sm text-red-600">{errors.name.message}</p>
            )}
          </div>

          <div>
            <label htmlFor="description" className="block text-sm text-gray-700 mb-2">
              Opis działu
            </label>
            <textarea
              {...register('description')}
              id="description"
              rows="4"
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
              placeholder="Opcjonalny opis działu"
            />
          </div>

          <div className="flex items-center justify-end space-x-3">
            <button
              type="button"
              onClick={() => navigate('/app/departments/list')}
              className="px-4 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
              Anuluj
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 text-sm text-white bg-primary-600 border border-transparent rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
            >
              {loading ? (
                <span className="flex items-center">
                  <LoadingSpinner size="sm" />
                  <span className="ml-2">Zapisywanie...</span>
                </span>
              ) : (
                'Dodaj dział'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DepartmentsAdd;
